export default function () {

  const $viewportWidth = $(window).width();
  const $heroContainer = $('.hero-container');
  const $videoContainer = $('.video-container');
  const $heroSection = $('.hero-section');
  
  if ($viewportWidth > 1079) {
    $videoContainer.html('<video src="../img/baxdela-maze-video.mp4" autoplay muted></video>');

    $('video').on('ended', function() {
      // animation effect reference: https://daneden.github.io/animate.css/
      $videoContainer.addClass('animated fadeOut');
      $heroSection.addClass('hero-background animated zoomIn');

      // used to prevent text flicker behind video on page load
      $heroContainer.css('opacity', '1');
    });
  } else {
    $heroSection.addClass('hero-background');
  }

}


// WEBPACK FOOTER //
// ./js/modules/hero-video.js